import { selectBasketSelectedPaymentKey, selectBasketBankTransfer, selectBasketCheckout, sendBasket, fetchInvoiceStatus } from 'containers/OrderDetails/basketSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import React, { useEffect, useRef } from 'react'

const useBankTransfer = (
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setPaymentMethodsAreVisible: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const selectedPaymentKey = useReduxSelector(selectBasketSelectedPaymentKey)
  const bankTransfer = useReduxSelector(selectBasketBankTransfer)
  const checkout = useReduxSelector(selectBasketCheckout)
  const attempts = useRef(0)

  const dispatch = useReduxDispatch()

  useEffect(() => {
    if (selectedPaymentKey === 'bank_transfer' && checkout?.payments && !bankTransfer) {
      const bankTransferPayment = (checkout.payments as any[]).find(payment => payment.key === 'bank_transfer')
      if (bankTransferPayment) {
        const payment = {
          amount: checkout?.to_pay?.now?.grossPrice,
          date: bankTransferPayment.date || 'now',
          methodId: bankTransferPayment.id,
          key: bankTransferPayment.key,
        }
        setLoading(true)
        dispatch(sendBasket({ step: 'finalizeBankTransfer', payments: [payment] })).then(res => {
          setLoading(false)
          if (!res.payload?.bankTransfer) {
            setPaymentMethodsAreVisible(true)
          }
        })
      }
    }
  }, [selectedPaymentKey, checkout, dispatch, bankTransfer, setLoading, setPaymentMethodsAreVisible])

  useEffect(() => {
    let active = true
    let timeout: NodeJS.Timeout
    const getStatus = () => {
      attempts.current += 1
      dispatch(fetchInvoiceStatus()).then(res => {
        if (active && res.payload?.status === 'INVOICE_PENDING') {
          if (attempts.current < 11) {
            timeout = setTimeout(getStatus, 5_000)
          }
        }
      })
    }

    if (bankTransfer?.status === 'INVOICE_PENDING') {
      timeout = setTimeout(getStatus, 1_000)
    }

    return () => {
      active = false
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [bankTransfer?.status, dispatch])

  return bankTransfer
}

export default useBankTransfer